module.exports = __webpack_public_path__ + "img/Footer_Background.6c80d6fe.png";